import { ToastContainer } from 'react-toastify';
import { Auth0Provider } from '@auth0/auth0-react';
import RoutesContainer from './Routes';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN || 'nanonets.auth0.com'}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || 'UqKi76Pt2q1RDEyiz3UfaKO0xDyWyOQJ'}
      authorizationParams={{ redirect_uri: `${process.env.REACT_APP_BACKEND_URL || "https://turing.nanonets.com"}/authorize` }}
    >
      <div className="App">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          draggable
          pauseOnHover
          theme="dark"
        />
        <RoutesContainer />
      </div>
    </Auth0Provider>
  );
}

export default App;
